import React from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import { useMutation, useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

// const LOGIN = gql`
// mutation($username: String!, $password: String!) {
//     login(username: $username, password: $password) {
//       token
//     }
//   }
// `;

const CONFIRMATION = gql `
mutation($username: String!, $password: String!){
  confirmation(username: $username, password: $password)
}
`

const GET_CURRENT_USER = gql`
query {
    currentUser {
      id
      username
      name
    }
}
`;

const UrlasserDialog = props => {
    const [canNotPerformActionDialogOpen, setCanNotPerformActionDialogOpen] = React.useState(false);
    const { open, onClose, onVerifyClick } = props;
    const [values, setValues] = React.useState({
      username: undefined, password: '', cause: '', initiator: ''
    });

    const [confirmation] = useMutation(CONFIRMATION, {variables:{ username: values.username, password: values.password }});
      
    const { data: currentUserData } = useQuery(GET_CURRENT_USER, { fetchPolicy: "cache-first" });
   
    const handleCanNotPerformActionDialogOpen = () => {
      if(!canNotPerformActionDialogOpen) {
        setCanNotPerformActionDialogOpen(true);
      }
    };
  
    const handleCanNotPerformActionDialogClose = () => {
      if(canNotPerformActionDialogOpen) {
        setCanNotPerformActionDialogOpen(false);
        onClose();
      }
    };

    if(currentUserData !== undefined) {

      //TODO implement canPerformActions check => project number needed
      // if(open) {
      //   if(!currentUserData.currentUser.canPerformActions) {
      //     handleCanNotPerformActionDialogOpen();
      //     return <CanNotPerformActionDialog open={canNotPerformActionDialogOpen} onClose={handleCanNotPerformActionDialogClose}/>;
      //   }
      // }

      if(values.username === undefined) {
        setValues({ ...values, ["username"]: currentUserData.currentUser.username });
      }
    } else {
      return null;
    }

    const handleChange = name => event => {
      setValues({ ...values, [name]: event.target.value });
    };

    const handleVerifyClick = async () => {
      if(await checkUsernamePassword(values.username, values.password)) {
        onVerifyClick(values.username, values.cause, values.initiator);
      }
      else {
        document.getElementById('authentication-problem').innerHTML='Passwort ist falsch. Authentifizierung fehlgeschlagen'
      }
    };

    async function checkUsernamePassword(username, password) {
      try {
        const result = await confirmation();
        return result.data.confirmation !== null;
        // confirmation().then(({data}) => {return data.login.token !== null }).catch(({e})=> {
        //   console.log(e);
        //   return false
        // })
      } catch (error) {
        return false;
      }
    };
    
    return (
      <Dialog open={open} onClose={onClose}>
        <DialogContent>
        <form noValidate autoComplete="off" style={{display: "flex", flexDirection: 'column'}}>
          <TextField
            label="Benutzername"
            margin="dense"
            value={values.username}
            disabled
          />
          <TextField
            required
            id="standard-password-input"
            label="Passwort"
            type="password"
            margin="dense"
            autoComplete="new-password"
            value={values.password}
            onChange={handleChange('password')}
          />
          <TextField
            required
            id="standard-required"
            label="Ursache"
            margin="dense"
            value={values.cause}
            onChange={handleChange('cause')}
          />
        <TextField
            required
            id="standard-required"
            label="Veranlasser"
            margin="dense"
            value={values.initiator}
            onChange={handleChange('initiator')}
          />
          <p id='authentication-problem' style={{color:'red', fontSize:10}}/>
        </form>
        </DialogContent>

        <DialogActions>
          <Button color="primary" onClick={onClose}>Abbrechen</Button>
          <Button color="primary" variant="contained" onClick={handleVerifyClick}>Bestätigen</Button>
        </DialogActions>
      </Dialog>
    );
};

UrlasserDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onVerifyClick: PropTypes.func,
};

export default UrlasserDialog;